<!-- PAGE TITLE================================================== -->

<section class="bg-light-red page-title-section top-position1 bg-img cover-background left-overlay-secondary">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="text-center">
                    <div class="position-relative">
                        <h1>Contact Us</h1>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>


<!-- Contact Us Section -->
<section class="contact-section">
    <div class="container">
        <div class="text-center mb-5">
            <!-- <h2 class="section-title display-6">Get In Touch</h2> -->
            <h4>We'd love to hear from you. Reach out to us anytime.</h4>
        </div>

        <div class="row g-2 justify-content-center">
            <!-- Contact Information -->
            <div class="col-lg-3">
                <div class="info-box h-100">
                    <!-- Email -->
                    <div class="mb-3">
                        <div class="d-flex align-items-center gap-3 mb-3">
                            <div class="contact-icon">
                                <i class="fas fa-envelope"></i>
                            </div>
                            <h4 class="mb-0">EMAIL US</h4>
                        </div>
                        <div class="ms-2 contact-info">
                            <a href="mailto:info@redmonkwellness.com" class="fs-5">
                                info@redmonkwellness.com
                            </a>
                            <br>
                            <a href="https://www.redmonkwellness.com" target="_blank" class="fs-5">
                                www.redmonkwellness.com
                            </a>
                        </div>
                    </div>

                    <!-- Call Us -->
                    <div>
                        <div class="d-flex align-items-center gap-3 mb-3">
                            <div class="contact-icon">
                                <i class="fas fa-phone-volume"></i>
                            </div>
                            <h4 class="mb-0">CALL US</h4>
                        </div>
                        <div class="ms-2 contact-info">
                            <!-- <a href="tel:+916262030303" class="d-block mb-2 fs-5">
                                +91 62-62-03-03-03
                            </a>
                            <a href="tel:+916262662662" class="d-block mb-2 fs-5">
                                +91 62-62-66-26-62
                            </a> -->
                            <a href="tel:+916262620303" class="d-block fs-5">
                                +91 62-62-62-03-03
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Mumbai Address -->
            <div class="col-lg-4">
                <div class="contact-card h-100 p-0">
                    <h4 class="address-title mb-3">ADDRESS - MUMBAI</h4>

                    <div class="map-container mb-4">
                        <div class="map-placeholder">
                            <div class="text-center">
                                <iframe
                                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3769.348970519019!2d72.8307769!3d19.1361959!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7b7f51afb0cdd%3A0x1e04ba476ec00617!2sRedmonk%20Wellness!5e0!3m2!1sen!2sin!4v1774066586794!5m2!1sen!2sin"
                                    width="100%" height="180" style="border: 0" allowfullscreen="" loading="lazy"
                                    referrerpolicy="no-referrer-when-downgrade"></iframe>
                            </div>
                        </div>
                    </div>

                    <p class="">
                        Unit No. B-36, Ground Floor A Wing, Laxmi Business Park, Laxmi Industrial Estate, Sab TV
                        Lane,
                        Off Link Road, Andheri West, Mumbai 400053.
                    </p>
                    <p> <a href="tel:+916262662662" class="d-block mb-2 fs-5">
                    Call Us: +91 62-62-66-26-62
                        </a></p>
                </div>
            </div>

            <!-- Kolkata Address -->
            <div class="col-lg-4">
                <div class="contact-card h-100 p-0">
                    <h4 class="address-title mb-3">ADDRESS - KOLKATA</h4>

                    <div class="map-container mb-4">
                        <div class="map-placeholder">
                            <div class="text-center">
                                <iframe
                                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3685.0200491952346!2d88.35462700000001!3d22.540921700000002!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a0277db6219589d%3A0x58c38cf723dfed72!2sRedmonk%20wellness!5e0!3m2!1sen!2sin!4v1774066501830!5m2!1sen!2sin"
                                    width="100%" height="180" style="border: 0" allowfullscreen="" loading="lazy"
                                    referrerpolicy="no-referrer-when-downgrade"></iframe>
                            </div>
                        </div>
                    </div>

                    <p class="">
                        Crescent Tower, Lala Lajpat Rai Sarani, 229, Acharya Jagdish Chandra Bose Rd, Sreepally,
                        Elgin, Kolkata, West Bengal 700020.
                    </p>

                     <p> <a href="tel:+916262030303" class="d-block mb-2 fs-5">
                    Call Us: +91 62-62-03-03-03
                        </a></p>


                </div>
            </div>
        </div>
    </div>
</section>